import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { UsersService } from './users.service';
import { Observable } from 'rxjs/Observable';
import { ShareDataService } from './share-data.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  private authService: UsersService;
  public currentLang: any;

  constructor(
    private injector: Injector,
    public activatedRoute: ActivatedRoute,
    public shareDataService: ShareDataService  
  ) {
    
    this.shareDataService.getLang().subscribe(data => {
      if (data) {
        this.currentLang = data.lang;
      }
    });
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.authService = this.injector.get(UsersService); // get it here within intercept
    let token = this.authService.isAuth() ? localStorage.getItem('user_login') ? JSON.parse(localStorage.getItem('user_login')).token : 'undefined' : 'undefined'; // your custom token getter function here
    let lang = this.currentLang ? this.currentLang : 'undefined';
    const authRequest = request.clone({
      headers: request.headers.set('authorization', token)
        .set('currentlang', lang)
    });

    return next.handle(authRequest);
  }
}
